module.exports = __webpack_public_path__ + "img/bg 05 blue.9896ab87.png";